import { render, staticRenderFns } from "./FourthScreen.vue?vue&type=template&id=cd7cbd08&scoped=true&"
import script from "./FourthScreen.vue?vue&type=script&lang=js&"
export * from "./FourthScreen.vue?vue&type=script&lang=js&"
import style0 from "./FourthScreen.vue?vue&type=style&index=0&id=cd7cbd08&lang=less&scoped=true&"
import style1 from "./FourthScreen.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7cbd08",
  null
  
)

export default component.exports